/**
 * #194 (D8) — règle de nouvelle tentative de React Query.
 *
 * Historique : `retry: 1`. Conservé, sauf sur un **429** : la requête vient
 * d'être refusée par le limiteur de débit, la rejouer aussitôt consomme le
 * compteur qui la bloque et prolonge l'attente de l'écran.
 */
export function retryUnlessRateLimited(failureCount: number, error: unknown): boolean {
  const status = (error as { response?: { status?: number } } | null)?.response?.status
  if (status === 429) return false
  return failureCount < 1
}
